import Spinner from "./Spinner.tsx";

export default function SpinnerContainer({ children = null, enabled = false, size = "lg" }: any) {
    return (
        <div style={{ position: 'relative' }}>
            {enabled && <div style={{ position: 'absolute', display: 'flex', width: '100%', height: '100%' }}>
                <Spinner
                    style={{ width: size === "sm" ? "35px" : "150px", height: size === "sm" ? "35px" : "150px", margin: 'auto', zIndex: 999 }}
                />
            </div>}
            <div style={enabled ? { opacity: 0.2, filter: 'blur(2px)', pointerEvents: 'none' } : undefined}>
                {children}
            </div>
        </div>
    );
}